export const defualtMeta = [
  {
    vmid: 'author',
    name: 'author',
    content: 'tonovation'
  }
]



// WEBPACK FOOTER //
// ./src/js/meta.js